import React from 'react';
import AuthFormModal from './AuthFormModal';
import { Checkbox } from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';
import { ReactComponent as Like } from '../svg/Like.svg';
import { ReactComponent as Dislike } from '../svg/dislike.svg';


export const UpvoteButton = ({ user, body, handleUpvote, size }) => {
  return user ? (
    <Checkbox
      checked={body.upvotedBy.includes(user.id)}
      icon={<SvgIcon  style={{ marginRight: '0.2em' }} fontSize="inherit" > 
      <Like style={{ color: "secondary" }} />
      </SvgIcon > }
      checkedIcon={<SvgIcon  style={{ marginRight: '0.2em' }} fontSize="inherit" > 
      <Like style={{ color: "secondary" }} />
      </SvgIcon > }
      onChange={handleUpvote}
      size={size || 'small'}
    />
  ) : (
    <AuthFormModal type="upvote" />
  );
};

export const DownvoteButton = ({ user, body, handleDownvote, size }) => {
  return user ? (
    <Checkbox
      checked={body.downvotedBy.includes(user.id)}
      icon={<SvgIcon  style={{ marginRight: '0.2em' }} fontSize="inherit" > 
      <Dislike style={{ color: "secondary" }} />
      </SvgIcon >}
      checkedIcon={<SvgIcon  style={{ marginRight: '0.2em' }} fontSize="inherit" > 
      <Dislike style={{ color: "secondary" }} />
      </SvgIcon >}
      onChange={handleDownvote}
      size={size || 'small'}
    />
  ) : (
    <AuthFormModal type="downvote" />
  );
};
